export const orderingValues = [
	{ name: 'Date of release', value: 'release_date' },
	// { name: 'Number of participants', value: 'participants_count' },
	// { name: 'Alphabetical A - Z', value: 'title_asc' },
	// { name: 'Alphabetical Z - A', value: 'title_desc' },
	{ name: 'Rate decending', value: 'rate_desc' },
	{ name: 'Rate accending', value: 'rate_asc' },	
];
